import script from "./SystemSettingsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSettingsScreen.vue?vue&type=script&setup=true&lang=js"

import "./SystemSettingsScreen.vue?vue&type=style&index=0&id=fb42bed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb42bed4"]])

export default __exports__